import { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { trackEvent } from 'src/api/db/apiAnalytics'
import { useSupabaseClient } from 'src/api/supabase'
import {
  RequestProvider,
  useRequestContext,
} from 'src/pages/_myAccount/Requests/Request/hooks/RequestContext'
import { LoadingState } from 'src/pages/ShareOrder/components/LoadingState'
import { ErrorState } from 'src/pages/ShareOrder/components/ErrorState'
import { ShareOrderProposal } from 'src/pages/ShareOrder/components/ShareOrderProposal'
import { ProductPreviewModeProvider } from 'src/shared/components/ProductGrid/ProductCard/ProductPreview/displayMode'

export const ShareOrderPage = () => {
  const { public_id } = useParams<{ public_id: string }>()

  return (
    <RequestProvider publicId={public_id} readOnly priceInQuoteCurrency>
      {/* Product details anywhere on the proposal (alternatives and the approved
          quote) show product information only, never catalogue prices. */}
      <ProductPreviewModeProvider mode="proposal">
        <ShareOrderBody />
      </ProductPreviewModeProvider>
    </RequestProvider>
  )
}

const ShareOrderBody = () => {
  const {
    quote,
    isQuotePending,
    isQuoteItemsPending,
    isError,
  } = useRequestContext()
  const supabase = useSupabaseClient()
  const trackedOpen = useRef(false)

  useEffect(() => {
    if (!quote?.id || trackedOpen.current) return
    trackedOpen.current = true
    trackEvent(supabase, {
      name: 'share_open',
      quoteId: quote.id,
      onceKey: `share_open:${quote.id}`,
    })
  }, [quote?.id, supabase])

  if (isQuotePending) {
    return <LoadingState />
  }

  if (isError || !quote) {
    return <ErrorState />
  }

  if (isQuoteItemsPending) {
    return <LoadingState />
  }

  return <ShareOrderProposal />
}
